<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Indicações" />

      <div class="flex flex-row-reverse items-end mb-4">
        <b-button
          class="is-primary ml-4"
          icon-right="refresh"
          @click.native="fetchInvites"
        >
          Atualizar Lista
        </b-button>

        <b-button
          text=""
          class="is-primary"
          icon-size="3"
          @click.native="cadastrar()"
        >
          Cadastrar
        </b-button>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="w-full flex">
        <label class="flex flex-col w-1/2 pb-6 pr-3">
          <Lynx-Label label="Data Inicial" />
          <b-datepicker
            v-model="form_pes.data_inicio"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
          />
        </label>
        <label class="flex flex-col w-1/2 pb-6 pr-3">
          <Lynx-Label label="Data Final" />
          <b-datepicker
            v-model="form_pes.data_fim"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
          />
        </label>

        <label class="flex flex-col w-1/2 pb-6 pr-3">
          <Lynx-Button
            text="Relatorio Indicações"
            class="mb-4"
            style="margin-top: 32px"
            @click.native="gerarRelatorio()"
            size="small"
            icon-size="3"
          />
        </label>
      </div>
    </div>

    <b-table :data="invites" paginated per-page="10">
      <template slot-scope="props">
        <b-table-column   label="#" field="id" v-text="props.row.id" />
        <b-table-column searchable sortable label="Cliente" field="customer.nome_completo">
          {{ props.row | customerTreatment }}
        </b-table-column>
        <b-table-column label="Status" field="status">
          {{ props.row.status }}
        </b-table-column>
        <b-table-column label="Indicação" field="invitee_name">
          {{ props.row.invitee_name }}
        </b-table-column>
        <b-table-column label="Contato" field="invitee_phone">
          <p>{{ props.row.invitee_phone }}</p>
          <p>{{ props.row.invitee_email }}</p>
          <p>{{ props.row.invitee_cpf }}</p>
        </b-table-column>
        <b-table-column label="desconto" field="desconto">
          <b-switch
            :value="props.row.desconto == 1"
            @input="changeDesconto(props.row)"
          />
        </b-table-column>
        <b-table-column label="vendedor" field="vendedor">
          <p v-if="props.row.vendedor">{{ props.row.vendedor.nome_completo  }}</p>
          <p v-if="!props.row.vendedor">    medcontabil  </p>


    

        </b-table-column>
        <b-table-column>
          <div class="flex text-sm items-center" v-if="hasRole('Editor') | hasPermission('editar indicacao')">
            <a href="#" class="mr-4 bg-primary-600 rounded-full p-2"
            @click.prevent="atualizar(props.row)"
            >
              <Icon-Edit class="text-neutral-100" size="4" />
            </a>
            <a
              href="#"
              class="bg-error-base rounded-full p-2"
              @click.prevent="deleteInvitee(props.row)"
            >
              <Icon-Trash class="text-neutral-100" size="4" />
            </a>
          </div>
        </b-table-column>
      </template>
      <template v-slot:empty>
        <NotFoundData text="Nenhum convite encontrado!" />
      </template>
    </b-table>
    <b-modal :active.sync="IndicacaoCadasModal" width="800px" id="modal-tall">
      <div class="bg-neutral-300 p-8">
        <div class="modal-body">
          <Lynx-Title text="Indicação" />
          <div class="w-full flex justify-between">

          <label v-if="!lista_campos.id" class="flex flex-col w-3/5">
            <Lynx-Label label="Cliente que indicou" />
            <b-autocomplete
              :data="filteredClientes"
              placeholder="Pesquise um Cliente"
              field="cliente"
              :loading="isFetching"
              @input="getAsyncCliente"
              @select="(option) => (form.customer_id = option.id)"
            />
          </label>
          <label v-if="lista_campos.id" class="flex flex-col w-3/5">
            <Lynx-Label label="edita quem indicou" />
            <b-autocomplete
              :data="filteredClientes"
              placeholder="Pesquise um Cliente"
              field="cliente"
              :loading="isFetching"
              @input="getAsyncCliente"
              @select="(option) => (form.customer_id = option.id)"
            />
          </label>
          <label v-show="form.customer_id == lista_campos.customer_id" v-if="lista_campos.id"  class="flex flex-col w-3/5">
            <Lynx-Label label="Cliente que indicou" />
            <Lynx-Input
            disabled
             :value="lista_campos.customer_id+' - '+lista_campos.customer.nome_completo"
              class="w-full "
            />
          </label>
            <!-- <Lynx-Label label="Nome da Cobrança" /> -->
            <label v-show="false" class="flex flex-col w-2/5">
              <Lynx-Input v-show="false" v-model="form.id" class="w-full" />
            </label>
            <label class="flex flex-col w-2/5 pl-1 ">
              <Lynx-Label label="Vendedor" />
              <!-- <b-select placeholder="Selecione um usuario" v-model="form.vendedor_id"> -->
                <!-- <option
                  v-for="(lista, index) in users"
                  :key="index"
                  :value="lista.id"
                  v-text="lista.nome_completo"
                /> -->

        <!-- <Lynx-Label label="Carteiras" /> -->

        <treeselect
          :multiple="false"
          :options="lista_usuarios"
          placeholder="Selecione um usuario..."
          v-model="form.vendedor_id"
        />

              <!-- </b-select> -->
            </label>
            </div>
          <div class="w-full flex justify-between">

            <label class="flex flex-col w-1/2 pl-1 pr-1">
              <Lynx-Label label="Nome completo" />

              <Lynx-Input
                placeholder="Insira o nome  do indicado"
                v-model="form.nome"
                class="w-full"
              />
            </label>
            <label class="flex flex-col w-1/2 pl-1 pr-1">
              <Lynx-Label label="email*" />
            <Lynx-Input
              placeholder="Insira o email do indicado"
              v-model="form.email"
              class="w-full "
            />
            </label>
          </div>
          <div class="w-full  flex   pt-2 ">
            <label class="flex flex-col w-1/2 pl-1 pr-1">
          
            <Lynx-Label label="CPF" />
            <Lynx-Input
              placeholder="Insira o CPF do indicado"
              v-model="form.cpf"
              class="w-full my-2"
              mask="###.###.###-##"
            />
            </label>
            <label class="flex flex-col w-1/2 pl-1 pr-1">

            <Lynx-Label label="Telefone" />
            <Lynx-Input
              placeholder="Insira o telefone do indicado"
              v-model="form.telefone"
              class="w-full my-2"
            />
            <!-- mask="(##) #####-####" -->

            </label>
          </div>

          <div class="flex flex-col mt-5">
            <Lynx-Button
              :disabled="lista_campos.status == ''"
              :text="!lista_campos.id ? 'cria' : 'edita'"
              class="mb-8"
              icon="Reload"
              @click.native="confirm(!lista_campos.id ? 'cria' : 'edita')"
              size="small"
              icon-size="3"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { clientesSearchRequest } from "@/services/requests/clientes";
import Treeselect from "@riophae/vue-treeselect";

import NotFoundData from "@/components/layouts/NotFoundData";
import {
  deleteInviteRequest,
  getInvitesRequest,
} from "@/services/requests/invites";
import { monthNames, dayNames } from "@/utils/utils";
import moment from "moment";
import debounce from "@/mixins/debounce";
import { usersRequest } from "@/services/requests/users";
import { hasRole, hasPermission } from "@/utils/can";

export default {
  name: "Indicacoes",
  components: { NotFoundData,Treeselect },
  mixins: [debounce],

  data() {
    return {
      users: [],

      form: {
        nome: "",
        email: "",
        cpf: "",
        telefone: "",
        customer_id: null,
        desconto: 0,
        vendedor_id: null,
      },
      monthNames,
      dayNames,
      moment,
      loading: false,
      invites: [],
      form_pes: {
        data_inicio: new Date(new Date() - 30 * 86400000),
        data_fim: new Date(),
      },

      IndicacaoCadasModal: false,
      lista_campos: {},
      isFetching: false,
      clientes: [],
      lista_usuarios:[],
      columns: [
        {
          field: 'id',
          label: 'ID',
          searchable: true,
          sortable: true,
        },
        {
          field: 'customer.nome_completo',
          label: 'Cliente',
          searchable: true,
          sortable: true,
        },
        {
          field: 'status',
          label: 'Status',
          searchable: true,
          sortable: true,
        },
        {
          field: 'invitee_name',
          label: 'Indicação',
        
        },
        {
          label: 'Contato',
       
        },
        {
          label: 'desconto',
        },
        {
          label: 'vendedor',
        },
      ],
    };
  },
  mounted() {
    this.fetchUsers();

    this.fetchInvites();
  },
  filters: {
    customerTreatment(value) {
      let name = "";
      if (value.customer && value.customer.empresa) {
        name += value.customer.empresa.map((a) => a.id).join(", ");
        name += " - " + value.customer.nome_completo.split(" ")[0];
      } else if (value.customer) {
        name += value.customer.nome_completo.split(" ")[0];
      }
      return name;
    },
  },
  computed: {
  
    mensagem_alert() {
      return this.$store.state.indicacao.mensagem_alert;
    },
    filteredClientes() {
      return this.clientes.map((item) => {
        return {
          id: item.id,
          cliente: `${item.id} - ${item.nome_completo}`,
        };
      });
    },
  },
  methods: {
    hasRole,
    hasPermission,
    async confirm(tipo, value) {
      await this.$buefy.dialog.confirm({
        message: `Esta ação  ` + tipo + ` um indicação no sistema?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          if (tipo == "edita") this.update();
        },
      });
    },
    async create() {
      this.loading = true;
      await this.$store
        .dispatch("indicacao/create_indicacao", this.form)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })

        .finally(() => (this.loading = false));

      this.IndicacaoCadasModal = false;
      this.listar_tipo_cobrancas();

      //   this.fireAlert({
      //     ...this.mensagem_alert,
      //     routeName: "produto",
      //   });
    },
    async update() {
      await this.$store
        .dispatch("indicacao/update_indicacao", this.form)

        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((error) => this.$snack.error(this.mensagem_alert.message))
        .finally(() => (this.loading = false));

      this.IndicacaoCadasModal = false;
      this.fetchInvites();
    },

    async changeDesconto(value) {
      await this.$store.dispatch("indicacao/apli_desconto_indicacao", value);
    },

    deleteInvitee(item) {
      if (!confirm("Tem certeza que deseja remover este convidado?")) {
        return;
      }
      this.loading = true;
      deleteInviteRequest(item.id)
        .then(() => this.fetchInvites())
        .catch((error) =>
          this.$snack.error(error.response.data.message || "Erro ao deletar")
        )
        .finally(() => (this.loading = false));
    },
    fetchInvites() {
      this.loading = true;
      getInvitesRequest(this.form_pes)
        .then((response) => (this.invites = response.data))
        .catch((error) => this.$snack.error(error.response.data.message))
        .finally(() => (this.loading = false));
    },
    gerarRelatorio() {
      this.$store.dispatch("empresas/gerarRelatorioIndicacao", this.form_pes);
    },
    cadastrar() {
      this.atualizar("");
      this.IndicacaoCadasModal = true;
    },
    atualizar(value) {
      this.lista_campos = value;
      this.form.id = value.id;

      this.form.nome = value.invitee_name;
      this.form.email = value.invitee_email;

      this.form.cpf = value.invitee_cpf;
      this.form.telefone = value.invitee_phone;
      this.form.customer_id = value.customer_id;
      console.log(this.form);
      this.IndicacaoCadasModal = true;
    },
    getAsyncCliente(name) {
      if (!name) return;
      let self = this;
      this.debounce(function () {
        self.isFetching = true;
        clientesSearchRequest(name)
          .then((response) => {
            self.clientes = response.data.data;
          })
          .catch((error) => self.$snack.error(error.response.data.message))
          .finally(() => (self.isFetching = false));
      }, 600);
    },
  async  fetchUsers() {
      this.loading = true;
    await  usersRequest()
        .then(
          (res) =>
            this.users = res.data.data
              
        )
        .catch(() => {
          this.$snack.error({
            text: "Ocorreu um erro, tente novamente mais tarde",
            button: "X",
          });
        })
        .finally(() => (this.loading = false));

      let usuarios = Object.values(this.users);
      
      let data = [];
      usuarios.forEach(element => {
        data.push({ id: element.id, label:element.nome_completo });
        
      });
        this.lista_usuarios = data
    },
  },
};
</script>

<style scoped>
</style>
